import ReactLoadable from 'react-loadable'
import React from 'react'
import * as Sentry from '@sentry/browser'

export const Spinner = () => {
  return (
    <div
      style={{width: '100%', height: '100vh'}}
      className="d-flex justify-content-center align-items-center">
      <div className="spinner-border">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  )
}

export const Loader = props => {
  if (props.isLoading) {
    if (props.timedOut) {
      Sentry.captureException(new Error('REACT_LOADABLE_TIMEOUT'), {props})
      return <div>:(</div>
    } else if (props.pastDelay) {
      return <Spinner />
    }
  } else if (props.error) {
    Sentry.captureException(new Error('REACT_LOADABLE_ERROR'), {props})
    console.warn(props.error)
    return <div>:(</div>
  }
  return null
}

const Loadable = opts =>
  ReactLoadable({
    loading: Loader,
    delay: 250,
    ...opts,
  })

export default Loadable
